import { formatDisplayDate } from '../utils/date';

function ItemList({ items = [], emptyMessage, showRecordDate = false, limit }) {
  const visibleItems = limit ? items.slice(0, limit) : items;

  if (!visibleItems.length) {
    return (
      <div className="rounded-lg border border-dashed border-gray-300 bg-white/70 px-4 py-8 text-center text-sm font-medium text-gray-600">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="grid gap-3">
      {visibleItems.map((item, index) => (
        <article
          key={`${item.subject || 'item'}-${item.deadline || item.record_date || index}`}
          className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm"
        >
          <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
            <h3 className="break-words text-base font-semibold leading-6 text-gray-950">
              {item.subject || 'Untitled'}
            </h3>
            {item.deadline && (
              <span className="inline-flex w-fit shrink-0 rounded-md border border-blue-200 bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700">
                {formatDisplayDate(item.deadline)}
              </span>
            )}
          </div>
          {item.data && (
            <p className="mt-2 whitespace-pre-wrap break-words text-sm leading-6 text-gray-700">
              {item.data}
            </p>
          )}
          {showRecordDate && item.record_date && (
            <p className="mt-3 text-xs font-medium text-gray-500">
              Posted {formatDisplayDate(item.record_date)}
            </p>
          )}
        </article>
      ))}
    </div>
  );
}

export default ItemList;
